module.exports = __webpack_public_path__ + "static/img/sad-confused.871fa25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guider/sad-confused.png
// module id = 3OvQ
// module chunks = 1